export default __webpack_public_path__ + "static/media/img21.72e80beb.jpg";